export enum ComparableStoreTypeEnum {
    AllStores,
    Comparables,
    NonComparables,
    map,
}
